import React, { useState } from 'react';
import styles from './VideoList.module.css';
import { AddBtnSvg } from '../../SVGComponents/SVGComponents';
import AddFilePopup from '../AddFilePopup/AddFilePopup';
import { useDispatch, useSelector } from 'react-redux';
import { deleteDocBd, deleteFile } from '../../firebase';
import LoaderPage from '../LoaderPage/LoaderPage';
import { deleteItemFromArrayRedux } from '../../store/slices/filesSlice';
import { getReadableFileSize } from '../../helper';

const VideoList = () => {
  const allFiles = useSelector((state) => state.files.files);
  const videos = (allFiles || []).filter((file) => file.fileType === 'video');

  const dispatch = useDispatch();

  const [activeVideo, setActiveVideo] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [loaderPage, setLoaderPage] = useState(false);

  const totalSize = videos.reduce((sum, video) => sum + video.size.size, 0);
  const totalSizeObject = getReadableFileSize(totalSize);

  const deleteVideo = async (videoObject) => {
    let isRemove = window.confirm('Видалити відео?');
    if (isRemove) {
      setLoaderPage(true);
      const isDeleteFile = await deleteFile(videoObject.url);

      if (isDeleteFile) {
        const isDeleteDoc = await deleteDocBd('files', videoObject.id);

        if (isDeleteDoc) {
          dispatch(deleteItemFromArrayRedux({ field: 'files', id: videoObject.id }));
        } else {
          alert('Не вдалося видалити документ!!!');
        }
      } else {
        alert('Не вдалося видалити відео!!!');
      }
      setLoaderPage(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header_list}>
        <h3 className={styles.title}>Відео з тренуваннями</h3>
        <button className={styles.addVideo_btn} onClick={() => setShowPopup(true)}>
          <AddBtnSvg />
        </button>
      </div>
      {videos.map((video) => (
        <div
          className={video.newFile ? styles.item + ' ' + styles.item_new : styles.item}
          key={video.id}>
          <div className={styles.header}>
            <h3 className={styles.title}>{video.title}</h3>
            <span className={styles.size}>
              {video.size.value}&nbsp;{video.size.label}
            </span>
          </div>

          <p className={styles.description}>{video.description}</p>

          <div className={styles.buttons}>
            <button className={styles.playButton} onClick={() => setActiveVideo(video.url)}>
              ▶ Переглянути
            </button>

            <button className={styles.deleteButton} onClick={() => deleteVideo(video)}>
              Видалити
            </button>
          </div>
        </div>
      ))}

      {/* POPUP */}
      {showPopup && <AddFilePopup onClose={() => setShowPopup(false)} fileType="video" />}
      {/* POPUP */}
      {activeVideo && (
        <div className={styles.popupOverlay} onClick={() => setActiveVideo(null)}>
          <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
            <video src={activeVideo} width="100%" height="350" controls className={styles.video} />

            <button className={styles.closeBtn} onClick={() => setActiveVideo(null)}>
              ✕
            </button>
          </div>
        </div>
      )}
      <div className={styles.foter_list}>
        <h3 className={styles.title}>Обший ромір</h3>
        <span className={styles.size}>
          {totalSizeObject.value}&nbsp;{totalSizeObject.label}
        </span>
      </div>

      {loaderPage ? <LoaderPage /> : ''}
    </div>
  );
};

export default VideoList;
